import {connect} from 'react-redux';
import DashboardReviews, {DashboardReviewsProps} from '../DashboardReviews/DashboardReviews';
import Constants, {DashboardFilter, SortMetric} from '../../globals/Constants';
import Action from '../../redux/Actions';
import {ModalStates} from '../../globals/Constants';
import ReduxState from '../../types/ReduxState';
import {Dispatch} from 'redux';
import UserModel from '../../types/UserModel';
import ReviewModel from '../../types/ReviewModel';

const getProperReviewStateObject = (dashboardFilter: DashboardFilter, reviews: ReviewModel[], filteredReviews: ReviewModel[], searchedReviews: ReviewModel[], searchText: string): ReviewModel[] => {
   if (searchText) {
      return searchedReviews;
   }

   if (dashboardFilter === DashboardFilter.all) {
      return reviews;
   }

   return filteredReviews;
};

const mapStateToProps = (state: ReduxState): Partial<DashboardReviewsProps> => {
   const {authorization, ownedReviewsCount, entitlements} = state;

   const isReviewsAtLimit = authorization &&
      authorization.quotas &&
      authorization.quotas.reviews > 0 &&
      ownedReviewsCount >= authorization.quotas.reviews;

   const isTrialActive = entitlements &&
      entitlements.level === Constants.entitlements.levels.trial &&
      authorization &&
      authorization.authorizedActions &&
      authorization.authorizedActions.canCreateReviews;

   return {
      reviews: getProperReviewStateObject(state.dashboardFilter, state.reviews, state.filteredReviews, state.searchedReviews, state.reviewSearchText) || [],
      currentUser: state.currentUser || {} as UserModel,
      authorizedActions: state.authorization.authorizedActions,
      themeName: state.themeName || Constants.themeName.default,
      searchText: state.reviewSearchText || '',
      dashboardFilter: state.dashboardFilter,
      isReviewsAtLimit: isReviewsAtLimit,
      isTrialActive: isTrialActive,
      reviewsSortMetric: state.reviewsSortMetric,
      totalReviewsCount: state.totalReviewsCount,
      totalOwnedReviewsCount: state.totalOwnedReviewsCount,
      totalNotOwnedReviewsCount: state.totalNotOwnedReviewsCount
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>): Partial<DashboardReviewsProps> => {
   return {
      setModalState: (modalState: ModalStates) => {
         dispatch(Action.setModalState({modalState}));
      },
      setSearchText: (searchText: string) => {
         dispatch(Action.setReviewSearchText(searchText));
      },
      setReviewsSortMetric: (reviewsSortMetric: SortMetric) => {
         dispatch(Action.setReviewsSortMetric(reviewsSortMetric));
      }
   };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardReviews);
